import { render, staticRenderFns } from "./DAScopedColumn.vue?vue&type=template&id=6fa60fd2&scoped=true"
import script from "./DAScopedColumn.vue?vue&type=script&lang=js"
export * from "./DAScopedColumn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fa60fd2",
  null
  
)

export default component.exports